import axiosInstance from '../../../config/axiosInstance';
import { ContactDocumentValidation } from "../View/Validation/ContactDocumentValidation";

const handleChange = (event, formData, setFormData) => {
    const { name, value } = event.target;
    setFormData({
        ...formData,
        [name]: value,
    });
};

const handleSubmit = async (event, formData, setFormData, setErrors, redirectCallback, redirectRoleList) => {
    event.preventDefault(); 

    const formErrors = ContactDocumentValidation(formData);   
    setErrors(formErrors);
    if (Object.keys(formErrors).length === 0) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const UserID = localStorage.getItem("UserID");
            const formDataToSend = new FormData();
            formDataToSend.append('ClientID', CompanyID);
            formDataToSend.append('UserID', UserID);
            Object.keys(formData).forEach(key => {
            if (key !== 'File') { // Skip the File key, we will handle it separately
                    formDataToSend.append(key, formData[key]);
                }
            });
            if (formData.File) {
                formDataToSend.append('File', formData.File);
            }
            const config = {
                headers: {
                   'Content-Type': 'multipart/form-data'
                }
            };
            const response = await axiosInstance.post(`/Customer/CreateContactDocument`,formDataToSend, config);     
             redirectRoleList();
        } catch (error) {
            console.error('Error posting data:', error);
        }
    }
};


export { handleChange, handleSubmit };
